import React from 'react';
import { styled } from '@linaria/react';

import { FrameType } from './DeferredValueTimeline.types';

const PATHS = {
  start: {
    hover:
      'M81.5574 198.557C86.6411 206.546 80.9026 217 71.4335 217H40.0414C33.3978 217 28.0186 211.602 28.0414 204.959L28.1468 174.341V17C28.1468 7.61115 35.7579 0 45.1468 0H49.1468C58.5356 0 66.1468 7.61115 66.1468 17V165.605C66.1468 171.31 67.7738 176.898 70.8369 181.711L81.5574 198.557ZM50.1468 17C50.1468 16.4477 49.6991 16 49.1468 16H45.1468C44.5945 16 44.1468 16.4477 44.1468 17V179V201H64.1468L50.1468 179V17Z',
    main: 'M48.1465 210H60.9559C65.6601 210 68.5345 204.833 66.0537 200.836L55.4544 183.759C53.2922 180.276 52.1465 176.257 52.1465 172.157V19C52.1465 16.2386 49.9079 14 47.1465 14C44.3851 14 42.1465 16.2386 42.1465 19V179V204C42.1465 207.314 44.8328 210 48.1465 210Z',
  },
  mid: {
    hover:
      'M81.5574 198.557C86.6411 206.546 80.9025 217 71.4334 217H22.8601C13.391 217 7.65243 206.546 12.7361 198.557L23.4566 181.711C26.5198 176.898 28.1468 171.31 28.1468 165.605V17C28.1468 7.61115 35.7579 0 45.1468 0H49.1468C58.5356 0 66.1468 7.61115 66.1468 17V165.605C66.1468 171.31 67.7738 176.898 70.8369 181.711L81.5574 198.557ZM50.1468 17C50.1468 16.4477 49.6991 16 49.1468 16H45.1468C44.5945 16 44.1468 16.4477 44.1468 17V179L30.1468 201H64.1468L50.1468 179V17Z',
    main: 'M33.3371 210H60.9559C65.6601 210 68.5345 204.833 66.0537 200.836L55.4544 183.759C53.2922 180.276 52.1465 176.257 52.1465 172.157V19C52.1465 16.2386 49.9079 14 47.1465 14C44.3851 14 42.1465 16.2386 42.1465 19V172.157C42.1465 176.257 41.0008 180.276 38.8386 183.759L28.2393 200.836C25.7584 204.833 28.6329 210 33.3371 210Z',
  },
  end: {
    hover:
      'M66.3986 204.959C66.4215 211.602 61.0422 217 54.3987 217H23.0066C13.5375 217 7.79891 206.546 12.8826 198.557L23.6031 181.711C26.6663 176.898 28.2933 171.31 28.2933 165.605V17C28.2933 7.61115 35.9044 0 45.2933 0H49.2933C58.6821 0 66.2933 7.61115 66.2933 17V174.341L66.3986 204.959ZM50.2933 17C50.2933 16.4477 49.8455 16 49.2933 16H45.2933C44.741 16 44.2933 16.4477 44.2933 17V179L30.2933 201H50.2933V179V17Z',
    main: 'M33.4836 210H46.293C49.6067 210 52.293 207.314 52.293 204V179V19C52.293 16.2386 50.0544 14 47.293 14C44.5315 14 42.293 16.2386 42.293 19V172.157C42.293 176.257 41.1472 180.276 38.9851 183.759L28.3858 200.836C25.9049 204.833 28.7793 210 33.4836 210Z',
  },
};

function SweeperSvg({ frameType = 'mid' }: { frameType: FrameType }) {
  const { hover, main } = PATHS[frameType];

  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={94 / 2}
      height={217 / 2}
      fill="none"
      viewBox="0 0 94 217"
    >
      <HoverBgPath
        fill="#fff"
        fillRule="evenodd"
        d={hover}
        clipRule="evenodd"
      />
      <path
        fill="#FFD500"
        stroke="#0F141B"
        strokeLinecap="round"
        strokeWidth="6"
        d={main}
      ></path>
    </Svg>
  );
}

const Svg = styled.svg`
  display: block;
  max-width: unset;
  mix-blend-mode: overlay;
`;

const HoverBgPath = styled.path`
  opacity: 0;
  transition: opacity 500ms;

  [data-sweeper='true']:hover & {
    opacity: 0.25;
    transition: opacity 150ms;
  }
  [data-sweeper='true']:focus-visible & {
    opacity: 0.5;
    transition: opacity 150ms;
  }
`;

export default SweeperSvg;
